import {Box, Table, TableBody, TableCell, TableRow, Tooltip, Typography} from "@mui/material"
import React from "react"

import {TransactionIcon} from "./TransactionIcon"
import {ScheduledPaymentRow} from "./ScheduledPaymentRow"

import {Transaction} from "@indebted/api"

function List(props: {Transactions: Transaction[]; reload: (delayMs?: number) => void}) {
	const {Transactions, reload} = props
	return (
		<Box sx={{width: "100%"}}>
			<Table>
				<TableBody>
					{Transactions.map((transaction, index) => {
						if (
							transaction.Type === "PaymentScheduled" &&
							transaction.CommitmentStatus === "pending" &&
							transaction.PaymentArrangementID &&
							transaction.ScheduledDate
						) {
							return (
								<TableRow key={index}>
									<TableCell colSpan={2} sx={{padding: 0}}>
										<ScheduledPaymentRow
											paymentArrangementID={transaction.PaymentArrangementID}
											title={transaction.Description}
											amount={transaction.Amount}
											scheduledDate={transaction.ScheduledDate}
											reload={reload}
										/>
									</TableCell>
								</TableRow>
							)
						}

						const {Amount, Date, Time, Type, Description} = transaction
						return (
							<TableRow key={index}>
								<TableCell>
									<Box display="flex">
										<TransactionIcon type={Type} />
										<Typography variant="body2">{Description}</Typography>
									</Box>
								</TableCell>
								<TableCell>
									<Box display="flex" justifyContent="end">
										<Box mr={2}>
											<Tooltip title={Time} placement="left">
												<Typography variant="caption" color="textSecondary">
													{Date}
												</Typography>
											</Tooltip>
										</Box>
										<Typography variant="body2">{Amount}</Typography>
									</Box>
								</TableCell>
							</TableRow>
						)
					})}
				</TableBody>
			</Table>
		</Box>
	)
}

export {List}
